import { render } from "./Freizeitanbieter.vue?vue&type=template&id=7431df88"
import script from "./Freizeitanbieter.vue?vue&type=script&lang=js"
export * from "./Freizeitanbieter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__